<template>
    <div>

    <!--Bread Crumb Wrap Start-->
    <div class="kode_about_bg">
    	<div class="container">
        	<div class="kode_aboutus_wrap">
            	<h4>Download Formulir Kependudukan</h4>
                <div class="kode_bread_crumb">
                	<ul>
                		<li><router-link to="/">Home</router-link></li>
                    	<li><router-link to="/formulir_kependudukan">Formulir Kependudukan</router-link></li>
                	</ul>
                </div>
            </div>
        </div>
    </div>
    <!--Bread Crumb Wrap Start-->   
    
     
        
    <!--Content Wrap Start-->
    <div class="kode_content" style="padding-top:5%">
    	
        <!--News List Wrap Start-->
        <section >
        	<div class="container">
                <div class="row">
                    <div class="col-md-6">

                            <select class="inputku1" v-model="layanan_id" @change="cari_data()">
                                <option value="">-- Semua Kategori --</option>
                                <option v-for="data in list_layanan" :key="data.master_kependudukan_id" :value="data.master_kependudukan_id">{{data.uraian}}</option>
                            </select>

                    </div>
                    <div class="col-md-6">
                            <input class="inputku" placeholder="Cari Data .." @keyup="cari_data" v-model="cari_value">
                      
                    </div>
                </div>
                <hr class="hrku" />
            	<div class="row">
                
                	<div class="col-md-8 kode_news_colmn_list">
                        <!-- list berita -->


                        <div v-if="loading" class="text-center">
                          <img src="images/loading.gif" alt="" width="30%">
                          <br>
                          <span style="color:#44c3f3; font-size:120%"><b>LOADING</b></span>
                          <br><br>
                        </div>


                        <template v-if="!loading">
                          <div class="kode_news_list" v-for="data in list_data" :key="data.id">  
                              <div style="float:left;">
                                  <a  @click="GetData(data)" data-toggle="modal" data-target="#myModal">
                                      <i class="fa fa-book" style="font-size:70px"> </i>
                                  </a>
                              </div>

                              <div style="padding-left:10%">
                                  <h5 style="font-size:150%"> 
                                    <a @click="GetData(data)" href="#" data-toggle="modal" data-target="#myModal"> 
                                      <b> {{data.nama}}</b> 
                                    </a> 
                                  </h5>
                                  <div><span class="h_tgl">Kategori : {{data.kategori_uraian}}</span> &nbsp; <i class="fa fa-calendar"></i> ({{convert_tgl(data.createAt)}})</div>
                                  <p v-html="data.deskripsi"></p>
                              </div>
                          </div>
                          
                        </template>
                        
                        
                        <!-- list berita -->
                        
                        
 
						<div class="clearfix clear"></div>
						<!--Pagination Wrap Start-->
						<div class="kode_pagination"  v-if="!loading">
							<ul class="pagination">
                                    <div class="text-center">
										<button @click="btn_prev" type="button" class="btn " id="pref">
											<span aria-hidden="true">&laquo;</span><span class="sr-only">Previous</span>
										</button>
										&nbsp;
										<span style="font-size: 85%; color: #a5a5a5">
											<b>{{page_first}} - {{page_last}}</b>
										</span>
										&nbsp;
										<button @click="btn_next" type="button" class="btn" id="next">
											<span aria-hidden="true">&raquo;</span><span class="sr-only">Next</span>
										</button>
									</div>
						
							</ul>
						</div>
						<!--Pagination Wrap End-->
                    </div>
                    
                    <div class="col-md-4">

                        
 
                        
						<!--Aside Event Wrap Start-->
                        <div class="kode_aside_event kode_aside">
                        	<h5>Kegiatan</h5>
                            <ul>
                            	<li v-for="data in kegiatan" :key="data.id">
                                	<figure>
                                    	<img :src="file_path+data.foto" alt="Image Here">
                                        <figcaption>
                                         
                                            <a href="javascript:void(0);" @click="push_kegiatan(data.id)"><i class="fa fa-link"></i></a>
                                        </figcaption>
                                    </figure>
                                    <div class="kode_aside_event_des" style="text-align:justify">
                                    	<p v-html="limit_desk_kegiatan(data.deskripsi)+' ...'"> </p>
                                    	<span><b>{{convert_tgl(data.createAt)}}</b></span>
                                    </div>
                                </li>
                                
 
                            </ul>
                        </div>
                        <!--Aside Event Wrap End-->
						
 
                        
 
                        
						<!--Aside Flicker Wrap Start-->
                        <div class="kode_aside_flicker kode_aside">
                        	<h5>Galleri Kegiatan</h5>
                        	<ul>
                            	<li v-for="data in kegiatan6" :key="data.id">
                                	<a href="javascript:void(0);" @click="push_kegiatan(data.id)">
                                		<figure>
                                    		<img :src="file_path+data.foto" alt="Image Here" style="height:90px;width:100%">
                                            <figcaption>
                                            	<i class="fa fa-plus"> </i>
                                            </figcaption>
                                    	</figure>
                                	</a>
                                </li>
                                
 
                            </ul>
                        </div>
						<!--Aside Flicker Wrap End-->
                        
                    </div>
                    
                    
                </div> 

                <!-- Button trigger modal -->


                <!-- Modal -->
                <div class="modal fade" id="myModal" role="dialog" aria-labelledby="myModalLabel" >
                <div class="modal-dialog modal-lg" role="document" >
                    <div class="modal-content" >
                    <div class="modal-header" >
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h6 class="modal-title" id="myModalLabel" ><small><b>LIHAT DATA</b></small></h6>
                    </div>
                    <div class="modal-body">

                         <h6><b> {{nama}} </b> </h6>
                                <hr>
                                <div class="text-center" v-if="file_tampil">
                                    <embed :src="file_path+foto" width="850" height="800" 
                                    type="application/pdf">
                                </div>
                        <hr>
                        <!-- <p v-html="isi"></p> -->
                        
                    </div>
                    <div class="modal-footer" >
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <a :href="file_path+foto" target="_blank" type="button" class="btn btn-default" style="background-color:#ef4a2b;color:#fff">Download</a>
                    </div>
                    </div>
                </div>
                </div>

                
            </div>
        </section>
        <!--News List Wrap End-->
        
    </div>
    <!--Content Wrap End-->

    


    </div>
</template>


<script>

// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import {ImageResize} from 'quill-image-resize-module'
// Quill.register('modules/imageResize', ImageResize)


// Quill.register("modules/imageResize", ImageResize);

const ADD_URL = URL_APP + "api/v1/publish_formulir_kependudukan/";
const ADD_URL_LAYANAN = URL_APP + "api/v1/publish_layanan_kependudukan/";
const KEGIATAN_URL = URL_APP + "api/v1/publish_kegiatan/";
const FILE_LOAD = URL_APP + "uploads/";

export default {
  name: "web_pengumuman",
  data() {
    return {
		id: "",
    layanan_id : '',
    nama : '',
    deskripsi: '',
    foto : '',
    kategori_uraian: '',
		createAt : '',
		createBy : '',
		judul : '',
		sumber : '',
		HOST : URL_HOST+'/isi_berita/',
    file_path: FILE_LOAD,

    file_tampil : false,

    loading : true,


    
    kegiatan:[],
    kegiatan6:[],

    list_data: [],
    list_layanan : [],
		page_first: 1,
		page_last: 0,
		cari_value: "",


    };
  },

  // =============================================================== METHODS =========================================================================
  // =============================================================== METHODS =========================================================================
  methods: {
    getView: function() {
        this.loading = true;
      fetch(ADD_URL + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          layanan_id: this.layanan_id,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          this.loading = false;
            // console.log(res_data);
        });
    },

    getLayanan(){
        fetch(ADD_URL_LAYANAN +'get_Kategori', {
            method: "GET",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            }
        })
        .then(res => res.json())
        .then(res_data => {
            this.list_layanan = res_data;
            this.layanan_id = res_data[0].master_kependudukan_id
            // console.log(res_data);
        });
    },

	

    getKegiatan: function() {
        fetch(KEGIATAN_URL + "getOne", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan = res_data;
                //   console.log(res_data);
            });
    },    

    getKegiatan6: function() {
        fetch(KEGIATAN_URL + "get6", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
        .then(res => res.json())
        .then(res_data => {
            this.kegiatan6 = res_data;
            //   console.log(res_data);
        });
    },     

    limit_desk_kegiatan : function(text){
      return text.substring(0, 100)
    }, 

    push_kegiatan : function(id){
      this.$router.push('/isi_kegiatan/'+id);
    },
	
    push_berita : function(id){
      this.$router.push('/isi_berita/'+id);
    },


    GetData: function(data) {
      // console.log(data)
      this.foto = data.foto;
      this.nama = data.nama;


      if (data.foto == '' || data.foto == undefined || data.foto == null) {
        this.file_tampil = false;
      } else {
        this.file_tampil = true;
      }

    },



// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function() {
      this.getView();
    },

    convert_tgl : function(dateString){
		var date = new Date(dateString);
		var bulan = "";

		if (date.getMonth() == 0) {bulan = 'januari';} 
		else if (date.getMonth() == 1) {bulan = 'Februari';}
		else if (date.getMonth() == 2) {bulan = 'Maret';}
		else if (date.getMonth() == 3) {bulan = 'April';}
		else if (date.getMonth() == 4) {bulan = 'Mei';}
		else if (date.getMonth() == 5) {bulan = 'Juni';}
		else if (date.getMonth() == 6) {bulan = 'Juli';}
		else if (date.getMonth() == 7) {bulan = 'Agustus';}
		else if (date.getMonth() == 8) {bulan = 'September';}
		else if (date.getMonth() == 9) {bulan = 'Oktober';}
		else if (date.getMonth() == 10) {bulan = 'November';}
		else if (date.getMonth() == 11) {bulan = 'Desember';}
		else{bulan = ''}

		return date.getDate()+" "+bulan+" "+date.getFullYear();
	},
// ================== PAGINASI ====================
  },
  // =============================================================== METHODS =========================================================================

  mounted() {
    this.getLayanan();
	this.getView();

  this.getKegiatan();
	this.getKegiatan6();
  }
};
</script>